<template>
    <div>
    <div class="container-fluid right_wrapper">
        <AddAsinScraperHeader></AddAsinScraperHeader>
        <AddAsinScraperDetails class="table_wrap no_footer pt-2"></AddAsinScraperDetails>
      </div>
    <!-- Modal Starts -->
    </div>
</template>

<script>
import AddAsinScraperHeader from '@/components/asin-scraper/AddAsinScraperHeader.vue'
import AddAsinScraperDetails from '@/components/asin-scraper/AddAsinScraperDetails.vue'

export default {
    components: {
        AddAsinScraperHeader,
        AddAsinScraperDetails
    },
	mounted(){
		this.$store.dispatch("getVendorForNameList")
	}
}
</script>

<style lang="scss">

</style>
